import { Timestamp } from '@src/common/time/Timestamp';
import { useCallback } from 'react';
import type { DateRange } from 'react-day-picker';

export const useDateRangeFormatter = (isUTC?: boolean) => {
  return useCallback(
    (range: DateRange): string => {
      const formatSingleDate = (date: Date) => {
        return isUTC
          ? new Timestamp(date).formatUTCDate()
          : new Timestamp(date).formatDate();
      };

      const { from, to } = range;
      return arrangeDates(from, to, formatSingleDate);
    },
    [isUTC],
  );
};

const arrangeDates = (
  from: Date | undefined,
  to: Date | undefined,
  formatSingleDate: (date: Date) => string,
) => {
  if (isEmptyRange(from, to)) return '';
  if (from && to) return `${formatSingleDate(from)} - ${formatSingleDate(to)}`;
  if (from) return formatSingleDate(from);
  if (to) return formatSingleDate(to);
  return '';
};

const isEmptyRange = (from?: Date, to?: Date): boolean => !from && !to;
